import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import PaisesScreen from './screen';
import { PaisesAdapter, Pais } from '../../../../../../infraestructure/persistence/rest/PaisesAdapter';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';

export const PaisesContainer = () => {

	const api = new PaisesAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let [ paises, setPaises ] = useState<any>([]);
	let result: any;

	useEffect(() => {
		console.log('llamada getPaises')
		getPaises();
	}, []);

	useEffect(() => {}, [ paises ]);

	const getPaises = async () => {
		try {
			result = await api.ListarPaises();
			if(result.data && result.data!=="")
			{
				setPaises([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	return (
		<>
			<PaisesScreen data={paises}/>
		</>
	);
};

export default PaisesContainer;
